import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-lower.svg";
import * as styles from "./Icon.module.scss";

type IconLowerProps = React.SVGProps<SVGSVGElement>;

export const IconLower = ({ className, ...props }: IconLowerProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
